export const bootstrapBreadcrumbProps = {
    items: {
        type: Array,
        required: true
    }
};
